import PropTypes from 'prop-types';
import React from 'react';
import PermissionBadge, { PERMISSION_BADGE_ENTITY } from '../../components/molecules/PermissionBadge';

const PermissionsCell = ({ agencyPermission = null, tdClassName = null, tdStyle = {} }) => (
    <td className={tdClassName} style={tdStyle}>
        {agencyPermission ? (
            <PermissionBadge
                state={agencyPermission.state}
                name={agencyPermission.name}
                entity={PERMISSION_BADGE_ENTITY.PARTNER_CONFIGURATION}
            />
        ) : (
            '-'
        )}
    </td>
);

PermissionsCell.propTypes = {
    agencyPermission: PropTypes.shape({
        name: PropTypes.string,
        state: PropTypes.string,
    }),
    tdClassName: PropTypes.string,
    tdStyle: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

export default PermissionsCell;
